<template>
  <div>
	<div class="data6">
		<div class="data6Left">
			<div class="data6LeftTil">
				便于诊疗
			</div>
			<div class="data6LeftBox">
				<div class="data6LeftFor" v-for="(item,index) in byzlList" :key="index">
					<div class="data6LeftForImg">
						<img :src="item.img" />
					</div>
					<div class="data6LeftForName">
						{{item.name}}
					</div>
					<div class="data6LeftForCen">
						{{item.cen}}
					</div>
				</div>
			</div>
		</div>
		<div class="data6Right">
			<img src="@/assets/product/page2/czjyZlys.png" />
		</div>
	</div>
  </div>
</template>

<script>
  export default {
    components: {
	
    },
    data() {
      return {
		byzlList: [{
				img: require('@/assets/product/page2/sscx.png'),
				name: '随时冲洗',
				cen: '诊疗过程中可随时启用，帮助视野保持清晰'
			},
			{
				img: require('@/assets/product/page2/dll.png'),
				name: '大流量',
				cen: '流量最高至每分钟450ml，为液体传输提供充足动力'
			},
			{
					img: require('@/assets/product/page2/llfdkz.png'),
					name: '流量分段控制',
					cen: '支持自动化流量分段控制，实现更精准的流量把握'
				},
				{
					img: require('@/assets/product/page2/znsstz.png'),
					name: '智能送水停止',
					cen: '持续送水20秒后自动停止工作，保障使用安全'
				},
		]
      }
    },
    mounted() {

    },
    methods: {

    }
  }
</script>

<style>

</style>
<style scoped lang="scss">
.data6{
	display: flex;
	.data6Left{
		flex:1;
		padding-left: 200px;
		.data6LeftTil{
			font-size: 45px;
			
			font-weight: bold;
			color: #000000;
			margin-bottom: 70px;
		}
		.data6LeftBox{
			display: flex;
			flex-wrap: wrap;
			width: 100%;
			.data6LeftFor{
				width: calc(49% - 40px);
				padding: 0 20px;
				margin-bottom: 70px;
				.data6LeftForImg{
					margin-bottom: 42px;
					img{
						width: 70px;
						height: 70px;
					}
				}
				.data6LeftForName{
					margin-bottom: 32px;
					font-size: 26px;
					
					font-weight: 400;
					color: #000000;
				}
				.data6LeftForCen{
					font-size: 18px;
					
					font-weight: 300;
					color: #000000;
				}
			}
		}
	}
	.data6Right{
		flex:1;
		img{
			width: 100%;
			height: 600px;
			object-fit: cover;
		}
	}
}
</style>
